
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import ForgotPassword from 'features/change-forgot-password/ForgotPasswordNonLoginSteps';
import { GuestLayout } from 'features/change-forgot-password/styled';

function ForgotPasswordPage() {
  return (
    <>
      <SEO title="Stockbit - Forgot Password" />
      <GuestLayout noBox isCompanyStock>
        <ForgotPassword />
      </GuestLayout>
    </>
  );
}

export default ForgotPasswordPage;
